import { ApiClient } from "../clients/api_client";
import { Block, NodeInfo } from "../clients/types";

export class NodeInfoCache {
    private static instance: NodeInfoCache|null = null;
    private nodeInfo: NodeInfo|null = null;
    private lastBlock: Block|null = null;

    private constructor() {}

    public static getInstance(): NodeInfoCache {
        if (NodeInfoCache.instance === null) {
            NodeInfoCache.instance = new NodeInfoCache();
            NodeInfoCache.instance.init();
        }

        return NodeInfoCache.instance;
    }

    public async getNodeInfo(): Promise<NodeInfo> {
        if (this.nodeInfo === null) {
            this.nodeInfo = await ApiClient.getInstance().queryNodeInfo();
        }

        return this.nodeInfo;
    }

    public async getLastBlock(): Promise<Block> {
        if (this.lastBlock === null) {
            this.lastBlock = await ApiClient.getInstance().queryLastBlock();
        }

        return this.lastBlock;
    }

    private init(): void {
        ApiClient.getInstance().subscribeOnClose(() => this.init());
        ApiClient.getInstance().subscribeBlockNew((block) => this.lastBlock = block).catch((reason) => console.error(reason));
    }
}
